import { useState, useEffect, useRef } from 'react';

type Tab = 'new-grad' | 'mid-career';

/* ─── 新卒採用 募集要項 ─── */
const newGradRequirements = [
  { label: '業種', value: 'システムエンジニア' },
  { label: '雇用形態', value: '正社員' },
  { label: '仕事内容', value: 'WEBシステムの設計・開発・運用/保守を行ってもらいます。\n設計:具体的にはお客様との折衝や設計書の作成。\n開発:プログラムの作成/テスト。\n運用/保守:リリース後の改修及び不具合修正。\n※お客様との折衝や設計書作成等の上流工程はスキルやプロジェクトの都合によります。また、本人の力量や意思も考慮しますが、重要なポジションまたは作業を積極的に任せていきたいと考えています。' },
  { label: '応募資格', value: '高等学校卒業以上\n※システム開発経験のある方、優遇致します' },
  { label: '勤務地', value: '東京周辺' },
  { label: '勤務時間', value: '9:00〜18:00\n※勤務地によって変動あり' },
  { label: '休日・休暇', value: '完全週休2日制、祝日、夏季、年末年始、有給休暇' },
  {
    label: '給与',
    value:
      '250,000円/月\n見込み残業(30h)含む+追加清算あり',
  },
  {
    label: '昇給',
    value: '年1回\n評価などにも寄りますが、1回の昇給で年収が10万〜20万ほど上がります。',
  },
  { label: '賞与', value: '年2回(計1ヶ月分)' },
  {
    label: '諸手当',
    value: '各種資格手当 (取得一時金・試験代補助)\n住宅手当(10,000円/月)',
  },
  { label: '交通費', value: '別途支給(30,000円/月)まで' },
  {
    label: '福利厚生',
    value:
      '社会保険、労働保険、住宅費補助、食事補助、退職金制度、結婚祝い金、不動産仲介手数料割引、シックリーブ制度(試用期間中のみ)',
  },
];

const newGradHighlights = [
  '毎年新卒採用を行っています。',
  '新卒者の殆どの人が文系です。',
  '新卒者に対する研修制度が充実しています。',
  '基本的にテスターのみの案件はやりません。',
  '残業は極力しないことを推奨します。',
  '残業しなくても30hの残業代を予め支給します。\nまた、30hを超える時間外労働については、追加で残業代を支給します。',
];

/* ─── 新卒 内定後の流れ ─── */
const careerSteps = [
  {
    period: '入社前（9月頃〜）',
    title: '入社前研修',
    desc: '入社後の外部研修で大きく出遅れないためのサポートが主な目的となります。\njava,sqlについて自宅で簡単な事前学習ができる教材を用意しています。\n各自のスキルやペースに合わせて課題に取り組めます。\n\n1. java問題集\n2. sql問題集\n3. 理解度チェックテスト',
    note: '※内定者研修を謳った就労や合宿などはありません。',
  },
  {
    period: '1年目（4月〜翌年3月）',
    title: 'OJT研修',
    desc: '1年目はOJTとして先輩社員と一緒に勤務となります。\nきっちりサポートしていきますので、プログラミング等未経験でも問題ありません。',
    note: '※現場配属が決まるまでの待期期間は外部でプログラミング(Javaなど)の研修を受けることがあります\n※給与全額支給、研修費用全額会社負担',
  },
  {
    period: '2〜3年目',
    title: '実践期間',
    desc: '新人としてOJT期間は終了しますが、引き続き先輩社員の元で仕事をします。',
    note: '※成長度合いや実力によっては一人で勤務してもらう場合もあります',
  },
  {
    period: '3〜5年目',
    title: '中堅社員へ',
    desc: '若手社員と呼ばれる期間も終わり、責任が伴います。\n今まで先輩社員から教わったように新入社員の指導をしながら働きます。',
    note: '※一人で勤務してもらう場合もあります',
  },
  {
    period: '5年目〜',
    title: 'リーダーへ',
    desc: '部下を持つようになります。',
    note: '',
  },
];

/* ─── システム開発工程 ─── */
const devProcessSteps = [
  { label: '要件定義', desc: 'お客様からどういうことをシステム化したいのかを聞き出すフェーズ', color: '#C85A5A' },
  { label: '基本設計', desc: '聞き出した要件をどのような仕様で実現するかを確定するフェーズ', color: '#A4C96B' },
  { label: '詳細設計', desc: '仕様をシステムとしてどの様に実装するかの設計をするフェーズ', color: '#8B7BA8' },
  { label: 'コーディング', desc: '設計書を元にコーディングをするフェーズ', color: '#5BA8B8' },
  { label: '単体テスト', desc: 'プログラム単体/画面単体のテストを行うフェーズ', color: '#E89B5A' },
  { label: '結合テスト', desc: '画面間連携のテストを行うフェーズ', color: '#C85A5A' },
  { label: '総合テスト', desc: 'システムのパフォーマンスや負荷テストを行い、想定に耐えられるかを確認するフェーズ', color: '#A4C96B' },
  { label: 'リリース', desc: 'システムの実運用を開始。リリース後は運用保守を行い、バグ対応や仕様変更を実施する', color: '#8B7BA8' },
];

/* ─── 中途採用 募集要項 ─── */
const midCareerRequirements = [
  { label: '職種', value: 'WEBシステムの開発・運用・保守SE' },
  { label: '雇用形態', value: '正社員' },
  {
    label: '仕事内容',
    value:
      '主に首都圏のプロジェクトにおける、WEBシステムの開発・運用・保守\n\n・管理：スケジュール管理・お客様への報告\n・設計：お客様との打ち合わせや設計書の作成\n・開発：プログラムの製造・テスト\n・運用・保守：リリース後の改修および不具合修正\n\n※上流工程はスキルやプロジェクトの都合によって担当を決定',
  },
  {
    label: '必要資格・経験',
    value:
      '＜必須＞\n・WEBシステム開発経験(3年以上)\n→Java・PHP・C#・Pythonなどの言語を用いた開発経験\n・客先常駐・リモートで勤務ができる方\n・単独でプロジェクト参画が可能な方\n\n＜歓迎＞\n・React.js、Vue.js、Next.jsなどのフロントエンド技術を保有している方\n・新人・若手の教育ができる方\n・サポート経験やリーダー経験のある方',
  },
  {
    label: '給与',
    value:
      '月給300,000円\n※固定残業代：63,000円 (30時間分)\n※固定残業代を除いた金額：237,000円\n※固定残業時間超過分は別途残業代を支給\n\n〇昇給あり(年1回)\n〇賞与あり(年2回)\n〇住宅手当あり\n\n＜収入例＞\n・月給34〜35万円(入社3年目)\n・月給35〜38万円(入社5年目)',
  },
  {
    label: '勤務地',
    value:
      '〒141-0031 東京都品川区西五反田8丁目7-11 アクシス五反田ビル 7階\n\n※客先エリアは基本的に都内（浜松町、門前仲町、大崎、品川など）',
  },
  { label: '最寄駅', value: 'JR山手線 / 五反田駅 徒歩6分\n東急池上線 / 大崎広小路駅 徒歩3分' },
  {
    label: '勤務時間',
    value:
      '9:00〜18:00（休憩1時間）\n※プロジェクト先の就労時間に準じます\n\n〇ほとんど残業なし（基本的に定時退社可能）\n1ヶ月の平均残業時間：0〜10時間',
  },
  {
    label: '休日休暇',
    value:
      '完全週休2日制（土・日曜）→年間休日126日※前年度実績\n\n・祝日（GW含む）\n・夏季休暇（3日間）\n・年末年始休暇（5日間）\n・有給 →100%消化しているスタッフもいます！',
  },
  {
    label: '福利厚生',
    value:
      '〇交通費支給（上限：¥30,000）\n〇食事補助あり（食の福利厚生チケットレストランを導入）\n〇資格取得支援あり（試験・参考書費用を会社が負担、合格時に手当を支給）\n〇不動産仲介手数料割引あり\n〇退職金制度\n〇髪型髪色自由（常駐先により変動有）',
  },
  { label: '加入保険', value: '社会保険完備' },
  { label: '受動喫煙防止措置', value: '屋内禁煙' },
  {
    label: '試用期間',
    value: '6ヶ月\n※期間中、条件の変動はありません。',
  },
  { label: '契約期間', value: '期間の定めなし' },
];

const midCareerAppeal = [
  '若手への教育とサポート体制が充実 → 資格取得支援制度を完備',
  '経営陣は元エンジニアで現場への理解あり',
  '食事補助＆住宅手当あり',
  '賞与年2回＆昇給年1回',
  '大手企業の案件多数で安定感も抜群！',
  'プロジェクトの約8割が在宅OK！',
];

/* ─── 中途 選考スケジュール ─── */
const selectionSteps = [
  {
    step: 'STEP 01',
    title: 'エントリー',
    desc: 'ページ下部のエントリーフォームより、必要事項をご記入のうえご応募ください。',
  },
  {
    step: 'STEP 02',
    title: '書類選考・面接（1〜2回）',
    desc: '※並行して適性検査（WEB）があります。\n※面接は基本オンラインになります。',
  },
  { step: 'STEP 03', title: '内定', desc: '後日、内定後の詳細をご案内します。' },
];

/* ─── テーブル行コンポーネント ─── */
const TableRow = ({
  label,
  value,
  isLast,
}: {
  label: string;
  value: string;
  isLast: boolean;
}) => (
  <div className={`flex flex-col md:flex-row ${!isLast ? 'border-b border-gray-100' : ''}`}>
    <div className="md:w-[180px] flex-shrink-0 bg-[#89B56B]/5 px-6 py-5 md:py-6">
      <span className="text-sm font-bold text-[#89B56B]">{label}</span>
    </div>
    <div className="flex-1 px-6 py-5 md:py-6">
      <p className="text-sm text-gray-600 leading-[1.9] whitespace-pre-line">{value}</p>
    </div>
  </div>
);

const RecruitRequirements = () => {
  const [activeTab, setActiveTab] = useState<Tab>('new-grad');
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [showDevProcess, setShowDevProcess] = useState(false);
  const devProcessSectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setIsVisible(true); observer.unobserve(el); } },
      { threshold: 0.05, rootMargin: '0px 0px -40px 0px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-16 bg-[#F8FAF6] relative overflow-hidden" id="requirements" ref={sectionRef}>
      {/* Background decoration text */}
      <div
        className={`absolute top-8 right-0 text-[48px] sm:text-[180px] font-bold text-[#89B56B]/5 leading-none select-none pointer-events-none tracking-tight anim-bg-text ${
          isVisible ? 'is-visible' : ''
        }`}
      >
        Requirements
      </div>

      <div className="max-w-6xl mx-auto px-6 lg:px-10 relative">
        {/* Section header */}
        <div className={`text-center mb-16 anim-fade-up ${isVisible ? 'is-visible' : ''}`}>
          <p className="text-[#89B56B] text-xs font-semibold tracking-[0.25em] uppercase mb-4 font-['Inter']">
            Requirements
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-[#89B56B]">募集要項</h2>
        </div>

        {/* Tab switcher */}
        <div className={`flex justify-center mb-12 anim-fade-up ${isVisible ? 'is-visible' : ''}`} style={{ transitionDelay: '0.15s' }}>
          <div className="inline-flex bg-white rounded-full p-1 shadow-[0_2px_12px_rgba(0,0,0,0.06)]">
            <button
              type="button"
              onClick={() => setActiveTab('new-grad')}
              className={`px-8 py-3 rounded-full text-sm font-bold transition-all duration-300 cursor-pointer whitespace-nowrap ${
                activeTab === 'new-grad'
                  ? 'bg-[#89B56B] text-white shadow-[0_4px_16px_rgba(137,181,107,0.35)]'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <span className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-graduation-cap-line text-base"></i>
                </span>
                新卒採用
              </span>
            </button>
            <button
              type="button"
              onClick={() => setActiveTab('mid-career')}
              className={`px-8 py-3 rounded-full text-sm font-bold transition-all duration-300 cursor-pointer whitespace-nowrap ${
                activeTab === 'mid-career'
                  ? 'bg-[#89B56B] text-white shadow-[0_4px_16px_rgba(137,181,107,0.35)]'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <span className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-briefcase-line text-base"></i>
                </span>
                中途採用
              </span>
            </button>
          </div>
        </div>

        {/* ═══════════ 新卒採用タブ ═══════════ */}
        {activeTab === 'new-grad' && (
          <div className="animate-fadeIn">
            {/* 参考情報 */}
            <div className="bg-white rounded-xl p-8 mb-12 shadow-[0_2px_16px_rgba(0,0,0,0.03)]">
              <h3 className="text-base font-bold text-[#89B56B] mb-5 flex items-center gap-2">
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-lightbulb-line text-[#89B56B] text-lg"></i>
                </span>
                参考情報
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {newGradHighlights.map((item, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-[#89B56B] text-sm"></i>
                    </span>
                    <span className="text-sm text-gray-600 whitespace-pre-line">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* 募集要項テーブル */}
            <div className="bg-white rounded-xl overflow-hidden shadow-[0_2px_16px_rgba(0,0,0,0.03)]">
              {newGradRequirements.map((item, index) => (
                <TableRow
                  key={index}
                  label={item.label}
                  value={item.value}
                  isLast={index === newGradRequirements.length - 1}
                />
              ))}
            </div>

            {/* ─── 内定後の流れ ─── */}
            <div className="mt-20">
              <div className="text-center mb-14">
                <p className="text-[#89B56B] text-xs font-semibold tracking-[0.25em] uppercase mb-4 font-['Inter']">
                  Career Path
                </p>
                <h3 className="text-2xl md:text-3xl font-bold text-[#89B56B]">内定後の流れ</h3>
              </div>

              <div className="relative">
                <div className="absolute left-6 top-0 bottom-0 w-px bg-[#89B56B]/20 hidden md:block"></div>
                <div className="space-y-10">
                  {careerSteps.map((step, index) => (
                    <div key={index} className="flex gap-8 items-start group">
                      <div className="hidden md:flex flex-col items-center flex-shrink-0">
                        <div className="w-12 h-12 rounded-full bg-[#89B56B] text-white flex items-center justify-center text-sm font-bold font-['Inter'] shadow-[0_4px_16px_rgba(137,181,107,0.3)] relative z-10">
                          {index + 1}
                        </div>
                      </div>
                      <div className="flex-1 bg-white rounded-xl p-8 group-hover:shadow-[0_4px_24px_rgba(137,181,107,0.1)] transition-all duration-300">
                        <div className="flex items-center gap-3 mb-3">
                          <span className="md:hidden w-8 h-8 rounded-full bg-[#89B56B] text-white flex items-center justify-center text-xs font-bold font-['Inter']">
                            {index + 1}
                          </span>
                          <span className="text-xs text-[#89B56B] font-semibold tracking-wider bg-[#89B56B]/10 px-3 py-1 rounded-full">
                            {step.period}
                          </span>
                        </div>
                        <h4 className="text-lg font-bold text-[#89B56B] mb-3">{step.title}</h4>
                        <p className="text-sm text-gray-600 leading-[1.9] whitespace-pre-line">{step.desc}</p>
                        {step.note && (
                          <p className="text-xs text-[#89B56B] mt-3 whitespace-pre-line">{step.note}</p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* ─── システム開発工程 ─── */}
            <div className="mt-20" ref={devProcessSectionRef}>
              <div className="text-center mb-14">
                <p className="text-[#89B56B] text-xs font-semibold tracking-[0.25em] uppercase mb-4 font-['Inter']">
                  Development Process
                </p>
                <h3 className="text-2xl md:text-3xl font-bold text-[#89B56B]">システム開発工程</h3>
              </div>

              <div className="flex flex-col lg:flex-row gap-12 items-start">
                {/* 左側: ウォーターフォール循環図 */}
                <div className="w-full lg:w-[420px] flex-shrink-0">
                  <div className="bg-white rounded-xl p-6 shadow-[0_2px_16px_rgba(0,0,0,0.03)]">
                    <img 
                      src="/image/recruit-development-process1.png"
                      alt="システム開発工程の循環図"
                      className="w-full h-auto"
                    />
                  </div>
                  {/* スマホ版のみ: 詳細を見るボタン */}
                  <div className="lg:hidden mt-4">
                    <button
                      type="button"
                      onClick={() => setShowDevProcess(!showDevProcess)}
                      className="w-full flex items-center justify-center gap-2 bg-[#89B56B] text-white text-sm font-bold py-3 px-6 rounded-lg shadow-[0_4px_16px_rgba(137,181,107,0.3)] cursor-pointer whitespace-nowrap transition-all duration-300 hover:bg-[#7aa55e]"
                    >
                      <span className="w-5 h-5 flex items-center justify-center">
                        <i className={`ri-${showDevProcess ? 'arrow-up-s-line' : 'arrow-down-s-line'} text-base`}></i>
                      </span>
                      {showDevProcess ? '閉じる' : '詳細を見る'}
                    </button>
                  </div>
                </div>

                {/* 右側: 各工程の詳細（縦フロー） */}
                {/* PC版: 常に表示 / スマホ版: ボタンで開閉 */}
                <div className={`flex-1 items-start ${showDevProcess ? 'flex' : 'hidden'} lg:flex`}>
                  {/* 工程リスト（縦ウォーターフォール） */}
                  <div className="flex-1 min-w-0 w-full">
                    {devProcessSteps.map((step, index) => (
                      <div key={index}>
                        {/* 工程行 */}
                        <div
                          className="flex items-stretch rounded-lg overflow-hidden border border-gray-200"
                          style={{ minHeight: 72 }}
                        >
                          {/* 工程ラベル */}
                          <div
                            className="flex items-center justify-center flex-shrink-0 text-white text-[12px] font-bold"
                            style={{
                              backgroundColor: step.color,
                              width: 110,
                              minHeight: '100%',
                            }}
                          >
                            {step.label}
                          </div>
                          {/* 説明文 */}
                          <div className="flex items-center px-5 py-3 flex-1 bg-white min-w-0">
                            <p className="text-[13px] text-gray-600 leading-[1.7] whitespace-pre-line">
                              {step.desc}
                            </p>
                          </div>
                        </div>
                        {/* 下向き矢印（最後の工程以外） */}
                        {index < devProcessSteps.length - 1 && (
                          <div className="flex justify-center py-1">
                            <div className="flex flex-col items-center">
                              <div className="w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[12px]" style={{ borderTopColor: step.color }}></div>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}

                    {/* スマホ版のみ: 下部の閉じるボタン */}
                    <div className="lg:hidden mt-4">
                      <button
                        type="button"
                        onClick={() => {
                          setShowDevProcess(false);
                          setTimeout(() => {
                            if (devProcessSectionRef.current) {
                              const top = devProcessSectionRef.current.getBoundingClientRect().top + window.scrollY - 80;
                              window.scrollTo({ top, behavior: 'smooth' });
                            }
                          }, 50);
                        }}
                        className="w-full flex items-center justify-center gap-2 bg-white text-[#89B56B] border border-[#89B56B] text-sm font-bold py-3 px-6 rounded-lg cursor-pointer whitespace-nowrap transition-all duration-300 hover:bg-[#89B56B]/5"
                      >
                        <span className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-arrow-up-s-line text-base"></i>
                        </span>
                        閉じる
                      </button>
                    </div>
                  </div>

                  {/* 担当範囲ブラケット（PC版のみ・1024px以上） */}
                  <div className="bracket-pc-only flex-shrink-0 relative" style={{ width: 160 }}>
                    <span
                      className="text-xs font-bold text-[#89B56B] whitespace-nowrap"
                      style={{ position: 'absolute', top: '198px', left: '5px' }}
                    >
                      プログラマ
                    </span>
                    <div
                      className="absolute"
                      style={{ top: "220px", height: "276px", left: "0px" }}
                    >
                      <div className="h-full border-r-2 border-t-2 border-b-2 border-[#89B56B] w-4 rounded-r-md"></div>
                    </div>
                    <span
                      className="text-xs font-bold text-[#5B8DB8] whitespace-nowrap"
                      style={{ position: 'absolute', top: '15px', left: '5px' }}
                    >
                      システムエンジニア
                    </span>
                    <div
                      className="absolute"
                      style={{ top: 36, height: 648, left: 80 }}
                    >
                      <div className="h-full border-r-2 border-t-2 border-b-2 border-[#5B8DB8] w-4 rounded-r-md"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ═══════════ 中途採用タブ ═══════════ */}
        {activeTab === 'mid-career' && (
          <div className="animate-fadeIn">
            {/* アピールポイント */}
            <div className="bg-white rounded-xl p-8 mb-12 shadow-[0_2px_16px_rgba(0,0,0,0.03)]">
              <h3 className="text-base font-bold text-[#89B56B] mb-5 flex items-center gap-2">
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-star-line text-[#89B56B] text-lg"></i>
                </span>
                求人のPOINT
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {midCareerAppeal.map((item, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-line text-[#89B56B] text-sm"></i>
                    </span>
                    <span className="text-sm text-gray-600">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* 募集要項テーブル */}
            <div className="bg-white rounded-xl overflow-hidden shadow-[0_2px_16px_rgba(0,0,0,0.03)]">
              {midCareerRequirements.map((item, index) => (
                <TableRow
                  key={index}
                  label={item.label}
                  value={item.value}
                  isLast={index === midCareerRequirements.length - 1}
                />
              ))}
            </div>

            {/* ─── 選考スケジュール ─── */}
            <div className="mt-20">
              <div className="text-center mb-14">
                <p className="text-[#89B56B] text-xs font-semibold tracking-[0.25em] uppercase mb-4 font-['Inter']">
                  Selection Flow
                </p>
                <h3 className="text-2xl md:text-3xl font-bold text-[#89B56B]">選考スケジュール</h3>
              </div>

              <div className="relative">
                <div className="absolute left-6 top-0 bottom-0 w-px bg-[#89B56B]/20 hidden md:block"></div>
                <div className="space-y-8">
                  {selectionSteps.map((item, index) => (
                    <div key={index} className="flex gap-8 items-start group">
                      <div className="hidden md:flex flex-col items-center flex-shrink-0">
                        <div className="w-12 h-12 rounded-full bg-[#89B56B] text-white flex items-center justify-center text-sm font-bold font-['Inter'] shadow-[0_4px_16px_rgba(137,181,107,0.3)] relative z-10">
                          {index + 1}
                        </div>
                      </div>
                      <div className="flex-1 bg-white rounded-xl p-8 group-hover:shadow-[0_4px_24px_rgba(137,181,107,0.1)] transition-all duration-300">
                        <div className="flex items-center gap-3 mb-3">
                          <span className="md:hidden w-8 h-8 rounded-full bg-[#89B56B] text-white flex items-center justify-center text-xs font-bold font-['Inter']">
                            {index + 1}
                          </span>
                          <span className="text-xs text-[#89B56B] font-semibold tracking-wider bg-[#89B56B]/10 px-3 py-1 rounded-full">
                            {item.step}
                          </span>
                        </div>
                        <h4 className="text-lg font-bold text-[#89B56B] mb-2">{item.title}</h4>
                        <p className="text-sm text-gray-600 leading-[1.9] whitespace-pre-line">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.4s ease-out;
        }
        .bracket-pc-only {
          display: none !important;
        }
        @media (min-width: 1024px) {
          .bracket-pc-only {
            display: block !important;
          }
        }
      `}</style>
    </section>
  );
};

export default RecruitRequirements;